import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import HeaderNoLogin from "common/HeaderNoLogin";
import LoadingPage from "common/Loading";

const LayoutNew = (props) => {
    const [isScrolled, setScroll] = useState(window.scrollY > 30);
    useEffect(() => {

        document.addEventListener("scroll", handleScroll);
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };

    }, []);

    const handleScroll = () => {
        const Y = window.scrollY;
        setScroll(Y > 30);
    };
    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => {
        setSidebar(!sidebar);
        if (sidebar === true) {
            props.isShowMenuShow();
        } else {
            props.isShowMenuHide();
        }
    };

    return (
        <Fragment>
            <div className="wrappNew">
                <div className="main-body bg-new">
                    <div className={`header_new toggledLeft`}>
                        <div className="iconSidebar">
                            <Icon
                                path={mdiMenu}
                                title=""
                                size={1.5}
                                style={{ color: "#707070" }}
                                onClick={showSidebar}
                            />

                        </div>

                        <HeaderNoLogin
                            className="top-left"
                        />
                    </div>
                    {props.isProgress ? <LoadingPage /> : null}
                    {props.isProgress1 ? <LoadingPage /> : null}
                    {/* <ProgressBarProvider isActive={props.isProgress} /> */}
                    <Fragment>
                        <div className="contentNew-main">
                            <div className="content-danhSach">{props.children}</div>
                        </div>
                    </Fragment>
                </div>
            </div>
        </Fragment>
    );
};

LayoutNew.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
        PropTypes.object,
    ]),
};

export default LayoutNew;
